import React from 'react';

import { useApp } from '../../../store/AppContext';
import { dayGridStyle, nameColumnWidth } from '../shared/style';
import HeaderCorner from './HeaderCorner';
import HeaderGrid from './HeaderGrid';

/* En-tête : coin fixe + grille des jours qui suit le scroll horizontal du corps (JS). */
export default function TimelineHeader({ monthGroups, weekGroups }) {
  const { COL, days, timelineGroupBy, timelineHeaderGridRef, timelineHeaderScrollRef } = useApp();
  return (
    <div className="flex shrink-0">
      <div
        className="shrink-0 grid [grid-template-columns:1fr]"
        style={{ width: nameColumnWidth(timelineGroupBy) }}
      >
        <HeaderCorner />
      </div>
      <div ref={timelineHeaderScrollRef} className="[flex:1] overflow-hidden">
        <div
          ref={timelineHeaderGridRef}
          style={{ ...dayGridStyle(days.length, COL), willChange: 'transform' }}
        >
          <HeaderGrid monthGroups={monthGroups} weekGroups={weekGroups} />
        </div>
      </div>
    </div>
  );
}
